import { WarehouseQuantity } from 'utilities/warehouse-quantity-columns';

export interface ShowroomStockEntry extends WarehouseQuantity {
  isCurrent: boolean;
}

// POS stock in every showroom (Stitches S5): this POS's showroom first, then the others in the
// order the API sends (by name).
export const orderShowroomStock = (
  warehouseQuantities: WarehouseQuantity[],
  currentWarehouseId: string,
): ShowroomStockEntry[] => {
  const entries = warehouseQuantities.map((entry) => ({
    ...entry,
    isCurrent: entry.warehouseId === currentWarehouseId,
  }));
  return [
    ...entries.filter((entry) => entry.isCurrent),
    ...entries.filter((entry) => !entry.isCurrent),
  ];
};
